const parts = [`field`];

const baseStyle = {
  field: {
    color: `heading`,
    fontSize: `md`,
    fontWeight: `semibold`,
    lineHeight: `normal`,
    _placeholder: {
      color: `placeholder`,
    },
  },
};

const variants = {
  outline: {
    field: {
      border: `2px solid`,
      borderColor: `border`,

      p: 4,
    },
  },
};

const sizes = {
  md: {
    field: {
      height: `auto`,
    },
  },
};

export const NumberInput = {
  parts,
  baseStyle,
  variants,
  sizes,
};
